import { api } from './index';
function index(phoneNumber) { const path = `/api/internal/obfuscated_orders?phone_number=${phoneNumber}`; return api({ method: 'get', url: path }).then(response => response.data.orders); }
function searchAll(phoneNumber) { const path = `/api/internal/obfuscated_orders/search_all?phone_number=${phoneNumber}`; return api({ method: 'get', url: path }).then(response => response.data.orders); }
export { index, searchAll };
